/**
 * 认人用的副标题：IAM 侧邮箱允许重复（很多人根本没填真实邮箱），
 * 登录名才是唯一能区分到人的字段，邮箱只作为老数据的兜底。
 * 返回 null 表示两者都没有，由调用方决定显示什么占位文案。
 */
export function identityLabelOf(person: { userName?: string | null; email?: string | null }): string | null {
  return person.userName?.trim() || person.email?.trim() || null;
}

/** 头像占位文字：中文取姓，拉丁名取前两个单词的首字母。 */
export function initialsOf(displayName: string): string {
  const name = displayName.trim();
  if (!name) return "?";
  if (/[一-龥]/.test(name)) return name[0] as string;
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}
